module.exports = __webpack_public_path__ + "img/product_76.6485e7c.webp";